// Module
var code = "<svg width=\"9\" height=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.91 4.26 2.181.784C1.455.435.727.87.727 1.565v6.87c0 .695.818 1.13 1.455.782L7.909 5.74a.872.872 0 0 0 0-1.478Z\"/></svg>";
// Exports
module.exports = code;